import { render, staticRenderFns } from "./Summary360Tab.vue?vue&type=template&id=6ece7030&scoped=true&"
import script from "./Summary360Tab.vue?vue&type=script&lang=js&"
export * from "./Summary360Tab.vue?vue&type=script&lang=js&"
import style0 from "./Summary360Tab.vue?vue&type=style&index=0&id=6ece7030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ece7030",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VCardTitle,VChip,VIcon,VProgressLinear,VSkeletonLoader})
